import styled, { css } from 'styled-components';
import { PcBox as BasePcBox, MobileBox as BaseMobileBox } from './general-title.default.box';
import { CssRule } from '../../themes/architecture/css-helpers/css-rule';
import { styledByDevice } from '../../themes/architecture/styled-by-device';

const common = css`
    font-family: ${({theme}) => theme.font.family.secondary};
    padding-left:4.5rem;
    text-transform: capitalize;
    padding-top:.6rem;
    padding-bottom:.6rem;
    font-size:2rem;
    font-weight: 300;
    border-left: none;
    z-index:0;
    clip-path: polygon(0 0, 10px 50%, 0 100%, 100% 100%, 100% 0);
    ${CssRule.For.RTL.build()} & {
        clip-path: polygon(0 0, 0 100%, 100% 100%, calc(100% - 10px) 50%, 100% 0);
    }
    &:before {
        content: "";
        position: absolute;
        background-image: url("${({theme}) => theme.images.spriteSheet.toString()}");
        height: 20px;
        width: 20px;
        top: 10px;
        left: 16px;
        background-position: -176px -766px;
        background-repeat: no-repeat;
        z-index:-1;
        ${CssRule.For.RTL.build()} & {
            transform: scaleX(-1);
        }
    }
`;

const PcBox = styled(BasePcBox)`
    ${common}
    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        padding: 1rem 5.5rem;
        font-size:2rem;
    }
`;

const MobileBox = styled(BaseMobileBox)`
    ${common}
    padding: .5rem 4rem;
    font-size: 1.6rem;
    &:before{
      background-position: -176px -819px;
    }
`;

export const GeneralTitleCasino777Box = styledByDevice(PcBox, MobileBox);
